import { config } from '@iheartjane/config';

const urlRoot = (storeId: string | number = '-0-') =>
  `${config.apiPath}/stores/${storeId}/specials`;

export const getCurrentStoreSpecials = (
  storeId?: string | number,
  sort?: string
) => ({
  url: sort ? `${urlRoot(storeId)}?sort=${sort}` : urlRoot(storeId),
});
